import ArticleText from "../../components/articleText.component"
import ArticleImgs from "../../components/articleImgs.component"
import ArticleHeader from "../../components/articleHeader.component"
import NavBar from "../../components/navBar.component"

const YosemiteTwoScreen = props => {
    const FOLDER = '2209Yosemite'

    const screen = {

    }

    return(<>
        <NavBar/>
        <div style={screen}>
            <ArticleHeader text='Land of the Giants: Part Two' date='04.02.22'/>
            <ArticleImgs folder={FOLDER} imgs={['thumbnail']}/>

            <ArticleText indent={true} text={`I’ve written about king lines before - the proud,
             long and sustained. The: if you could go anywhere, you’d go right up the middle of
              that bit. The Nose is exactly that bit of El Capitan. And El Capitan is that bit
               of Yosemite. Just shy of a vertical kilometre, the central prow of El Capitan is
                more than two and a half times the height of the Empire State Building. It's
                 the tallest continuous rock face in the Yosemite Valley, and there 
                are only a small handful of walls any larger across the world. The protruding 
                Nose steps into the East-West valley to such an extent that its vast 
                flanks take turns in a cool shade each day.`}/>

            <ArticleImgs folder={FOLDER} imgs={['JoeElCap']}/>  

            <ArticleText text={`Only around 10 people have free-climbed the Nose at the time 
            of writing this. Yet, the route is the busiest climb in the valley. A few very 
            difficult pitches make a free-ascent out of the realms of consideration for most 
            climbers. So, of the hundreds of teams on the Nose every season (only around half 
            of whom make it to the top), nearly all of them are aid-climbing quite a few of the 
            pitches.`}/>

            <ArticleText text={`And the people 
            who don’t get to the top? As a result of its popularity, there are well-equipped 
            escape routes from various points in the first half of the climb.`}/>

            <ArticleText text={`How hard is the aid climbing? Not very - and this creates a bit 
            of a problem. It’s one of the most coveted climbs in the valley, not 
            technically difficult, forgiving to the underprepared, and the queues of 
            teams strung along the route eliminate the need for anything that resembles route 
            finding. So why climb it? At the end of the day, it will always be the Nose, and 
            you'll always want to. And truthfully, the scale of the route did still 
            excite the adventurer within. 2 or 3 days can always be struggled through in 
            pretty sub-optimal conditions, but 5 days - not so much.`}/>

            <ArticleText text={`It's not often the case that I'm motivated to climb something to get a 
            tick in a box. But if that is the case, then you better be damn 
            sure you're going to make it to the top. Three or so weeks in the valley isn't as long as it sounds when a 
            single climb can take 5 days, so preparing a piss-poor 
            performance prior to our flight seemed like the right idea. The nearest 
            small-wall to London was a chossy sea cliff near Bournemouth which prepared 
            us only for the baking Californian sunshine and the fact that aid-climbing is 
            fundamentally un-enjoyable.`}/>

            <ArticleImgs folder={FOLDER} imgs={['swanageKit','swanageEd']}/>  

            <ArticleText indent={true} text={`We set off up an unestablished micro crack 
            in a dusty groove which turned out to be harder and more scary than any of the 
            aid-climbing that I did in the Yosemite Valley. A couple of RP’s equalised with 
            a sling, and a #0.2 microcam exploding with a fractured lobe - all above a ground fall 
            potential. For the inquisitive: it definitely wasn’t an official first-ascent once I had 
            put a micro-trax on the abseil line as a backup (having remembered it was just a training 
            trip, and that breaking a leg would look really silly). `}/>

            <ArticleText indent={true} text={`We were four, stood at the toe of the Nose in the 
            purple-blue dawn of the first day. It didn’t look altogether that far to the top, 
            though the shapes taken on by the roofs, boots and towers looked unfamiliar: distorted 
            and compressed. It was more bewildering than intimidating. `}/>

            <ArticleImgs folder={FOLDER} imgs={['bewildering']}/>

            <ArticleText text={`Strategy plays a big part in the early stages of the climb when 
            the ground is still within arm’s reach. Avoiding queues, maximising progress, and 
            saving food and water – all good things in the balance. It's popular to climb to Sickle 
            Ledge, around 150m up, without haul bags, then abseil back 
            to the ground using three ropes tied together. You can then spend one more night in 
            luxury, before ascending your fixed ropes and hauling your bags up to your high point. 
            Word was going round that the queues had been bad over the last few days. We had even 
            spoken to a team from North Wales who had had to bail on day two - likely to run out 
            of food and water in the hold up. In a bid to get out ahead of rush-hour, we were 
            going to haul our bags to our high point on day 1 and sleep on the ledge. One more night on 
            the wall in favour of starting pitch 5 at dawn on day 2. `}/>

            <ArticleImgs folder={FOLDER} imgs={['sickleSwing']}/>

            <ArticleText text={`Myself, Jo and Stu set off for Sickle. The peg-scarred 
            cracks were really worn out and it made for some of the most insecure climbing on 
            the route. Two teams of locals passed us, climbing very fast and light to 
            practice just this first section of the Nose in preparation for a NIAD (Nose In A 
                Day) later in the season. They all said it’s plain sailing once you get through 
                Stovelegs. `}/>
            
            <ArticleImgs folder={FOLDER} imgs={['sickleSwung','standInAider']}/>

            <ArticleText text={`Jo was turning 30 in 6 days’ time, and the 30 pitches between 
            us and the top were no coincidence. She is also a brilliant photographer and I’ve 
            used her photos alongside mine throughout this article. A camera in each climbing 
            pair was sensible – so once at Sickle, I would abseil to the ground to meet Alex 
            and the bags, while Stu and Jo fixed the first pitch above Sickle. We would need 
            some separation between our 2 sub-teams for the rest of the route. Unfortunately, 
            that’s not quite how it panned out.`}/>

            <ArticleText indent={true} text={`At 2am the next morning, slouched on an poorly hung 
            inflatable portaledge, I tipped a pouch of cold Chana Masala into my mouth in 
            between frankfurters. The other three were asleep. Alex - on a small sloping ledge 
            to my left, 4.5 ft square. Stu and Jo on a 2-man portaledge hanging 
            just above Alex, leaving no room to sit up. The others had eaten while I was making 
            my second trip down the fixed lines, this time in the dark, to attach the other bag 
            to the rope for 
            hauling. The plan of hauling both bags in one go had failed miserably. We had used 
            a 3-to-1 space hauling setup for the first 60m which turned out to be too slow 
            and awkward. There was 105 kg of water in the bags before even considering the 
            weight of portaledges and food. `}/>

            <ArticleImgs folder={FOLDER} imgs={['void']}/>

            <ArticleText text={`Part way through hauling the first bag up the final 120m to 
            the ledge, some of the team had a bit of a calorie meltdown - physically and 
            emotionally drained by the day. I think falling so short of the plan introduced 
            a lot of doubt into people’s minds. Truthfully, I felt frustrated and a bit 
            betrayed in what felt like an atmosphere of resignation. I feel it’s 
            important to add that we would never have got the second bag up to the ledge if 
            it weren’t for Stu’s relentless hauling efforts. `}/>

            <ArticleImgs folder={FOLDER} imgs={['perchedPortaledge']}/>

            <ArticleText indent={true} text={`An early start on day 2 didn’t happen. I set 
            a late alarm for around 7am which was when we should have been packed up and 
            setting off. I was worried moral was low and getting up in the dark might have 
            been too overwhelming. I don’t believe anyone else set an alarm, certainly no 
            one set one before 7. We had a discussion that morning about some or all of 
            us bailing, before deciding to carry on and re-asses the following morning. 
            Camp for the second night would be Dolt Tower, and the escape options from 
            there are pretty friendly with a line of abseil bolts straight to the ground.`}/>

            <ArticleImgs folder={FOLDER} imgs={['alexLook','knots']}/>

            <ArticleText text={`Five pitches were between us and Dolt Tower, including 
            the renown Stovelegs crack system. We split into our two climbing teams. I 
            led and hauled the five pitches to Dolt to give Alex the best chance to 
            have a calorie surplus recovery day. We were in bed by 9pm having had a 
            desperately tasty warm dinner. The ledge nearly felt like the ground. Two 
            or three flat-ish spots about the size of a person separated by rocky steps. `}/>

            <ArticleImgs folder={FOLDER} imgs={['doltLedge']}/>

            <ArticleText text={`The morning brought frank discussion and difficult 
            decisions. We talked through several options. Alex decided to go down. He 
            felt that he had not bounced back from our ascent of the West Face of Leaning 
            Tower. There had only been one rest day at base camp before setting off up 
            the Nose which just wasn’t enough time to fully recover and build up energy 
            reserves for a week on El Cap. Others expressed doubts and 
            indecision too, and a final decision about what the team would look like 
            moving forwards wasn’t made until after breakfast. `}/>

            <ArticleImgs folder={FOLDER} imgs={['decisionMaking','portaledgeStu']}/>

            <ArticleText text={`I was determined to continue and did believe what we 
            had been told: it gets easier the higher you go – less time wasted in 
            queues, you get the hang of moving faster, the bags get at least 15-20 
            kg lighter every day. That being said, I thought for the first time that 
            it might become gruelling to the extent that I would rather not be doing 
            it. I have never reached that point on a climb before, and thankfully 
            it didn’t happen on the Nose. `}/>

            <ArticleText text={`A couple of older guys, one of whom was turning 60, 
            appeared on the ledge and were looking to head down 
            after their morning run up the first 9 pitches. They’d each done a 
            handful of NIADs with other partners over the years and were seeing 
            how fit they were feelings before potentially doing one together the 
            following week. Alex would have some company for the 16 abseils. Stu, Jo 
            and I started pitch 10 of 30 knowing that we had just committed to 
            a battle for the top. `}/>

            <ArticleText text={`Our next camp was only three pitches away, and 
            yet it still felt really good to get there with hours of daylight to 
            spare. We needed to come together a bit more as a team and making good 
            progress put us all in a better mood. El Cap Tower
            was the only camp on the wall that left me wishing we could have stayed another 
            night. As though cut into the face with flat-chisel and hammer.`}/>

            <ArticleImgs folder={FOLDER} imgs={['waterBefore','stuElCapT']}/>

            <ArticleText indent={true} text={`There wasn’t really time to bask in the sun and 
            our sense of position. Stu was tired having led the last block from Dolt and Jo 
            didn’t want to climb the next pitch: Texas Flake. I don’t know why the pitch 
            doesn’t get more publicity – it seems to me to be a hidden crux of the whole route. 
            It was the only part that felt truly irresponsible, and that thought came to me 
            halfway up it. Feet on one wall, back pressed up against the wall opposite – the 
            two walls making up the sides of a ridiculous 3ft wide alley between two 50ft 
            tall buildings. There’s one bolt halfway up on the far right, but the topo said 
            it was easier on the left, so left and bolt-less it was. I was watching the rope 
            dangling between my legs, not clipped to anything between me and a gentle curl 
            as it lay on the rocky bottom of this crazy aerial alley. To be honest, it’s 
            unpleasant to write about even now. Stood on top of the 
            huge flake was the only time I felt the sense 
            of extreme exposure that comes with a kilometre high rock face. The rest of the 
            time I was totally acclimatised. Waking up to the drop, hanging in hundreds of 
            meters of darkness, none of these times was I moved from the surreal to the 
            frightened – but climbing 50ft essentially unattached really reset my system. `}/>

            <ArticleImgs folder={FOLDER} imgs={['exposedLadder']}/>

            <ArticleText text={`Darkness fell as I started up the Boot Flake. Jo and I sang 
            as she belayed me. Sweet Caroline, Escape (the Pina Colada song), I'm Gonna Be 
            (500 Miles). I felt elated to have cheated broken arms and legs, and by the end 
            of the pitch we would have reached the King Swing, which was a real milestone. 
            Jo was excited that we were the lonely headtorches she’d gazed up at from El Cap 
            Meadow so many times before.`}/>

            <ArticleImgs folder={FOLDER} imgs={['ECTStu']}/>

            <ArticleText indexnt={true} text={`The morning on day 4 was not representative 
            of big wall breakfasts. It’s harder to take photos at the terrible bivvies, so 
            it doesn’t happen. Jo’s friend had recently started a dehydrated meals brand, 
            so we tried to do some modelling for them. It’s possible the target audience 
            might find it an attractive advert – though that says as much about them as 
            it does about us after 3 days on the wall.`}/>

            <ArticleImgs folder={FOLDER} imgs={['modelingSolo', 'modelingGroup']}/>

            <ArticleText text={`The meals were delicious, but I do think they ought to be 
            tested by averagely hungry folk on the ground.`}/>

            <ArticleImgs folder={FOLDER} imgs={['haul1','haul2','stuFish']}/>

            <ArticleText indent={true} text={`The rest of the Nose felt more like a process. 
            We did get into a groove and the bags did get much lighter. I remember being 
            surprised on the sixth day, climbing an awkward C2 pitch with so much 
            momentum. For a moment understanding how it might feel to climb the route in a day. 
            It’s possible that really needing to pee had something to do with my 
            blistering pace – then again, I don’t imagine there are many loo breaks on a 
            NIAD. `}/>

            <ArticleImgs folder={FOLDER} imgs={['stuToe']}/>

            <ArticleText text={`Dusting off my climbing shoes and free-climbing Pancake 
            Flake on-sight stays with me as a vivid memory. Dealing with horrendous flash-pump 
            and not much in the way of energy reserves made it quite a fight. 
            A layback crack at the centrefold of a huge blank book, the pancake-thin 
            page rings when the gear on your harness chimes it. `}/>

            <ArticleImgs folder={FOLDER} imgs={['ascendingJo']}/>

            <ArticleText indent={true} text={`Stu might have more to say about the 
            aid-climbing challenges in the upper sections of the Nose. I belayed him 
            through the Great Roof and Changing Corners - both iconic and epic pitches, 
            both in the dark, on two 
            consecutive nights. Mainlining Shot Bloks and occasionally shivering in the 
            cooling night-time breeze kept me awake while Stu had a significantly worse 
            time, swearing on the other end of the rope.`}/>

            <ArticleText indent={true} text={`We stood on the top and I didn’t feel a 
            huge sense of achievement. I am more proud of it now, some time later. It 
            took a while to figure out why I didn’t feel on top of the world - on top 
            of the rock; next to the wind-twisted pines and a couple of 
            not-for-the-first-time NIAD climbers who set off that morning. `}/>

            <ArticleImgs folder={FOLDER} imgs={['grouppose']}/>

            <ArticleText text={`If we were slower, we would have made it. If we packed 
            less stuff, or more stuff; we would have made it. The hardest pitches 
            weren’t that hard, it wasn’t that cold, or that hot. We carried a 
            full, unopened jar of peanut butter to the top; because we had space for 
            it but didn’t need it. These thoughts circulated as we trudged back down 
            to the valley floor carrying our ridiculously big bags, and our unopened 
            jar of peanut butter. If the romantic dream of the biggest walls in 
            Yosemite was indeed more than just a dream, climbing the Nose in 
            this style wasn’t it. If you can’t climb it fast enough, take more food. 
            If it doesn’t all fit in your rucksack, take a bigger bag. If you can’t 
            carry your heavy kit, haul your bags. If the bags are just too heavy, 
            then build a bigger pulley. `}/>

            <ArticleText text={`For me, something in the adventure is squashed by 
            this brutish approach.`}/>

            <ArticleImgs folder={FOLDER} imgs={['packup','walkoff']}/>

            <ArticleText text={`But Jo did get to spend her 30th birthday climbing 
            the final pitch to the summit of El Cap, and we did have a really fun 
            time (for some of it).`}/>

            <ArticleImgs folder={FOLDER} imgs={['joebirthday']}/>

            <ArticleImgs folder={FOLDER} imgs={['stumacro','edmacro']}/>

            <ArticleImgs folder={FOLDER} imgs={['teeth']}/>

        </div>
    </>)
}

export default YosemiteTwoScreen